import generated from './company.generated.json';

interface PublicCompanyDetails {
  organization: {
    full_name: string;
    short_name: string;
    legal_address: string;
    inn: string;
    kpp: string;
    ogrn: string;
  };
  bank_account: {
    settlement_account: string;
    bank_name: string;
    bank_inn: string;
    bank_bik: string;
    correspondent_account: string;
    bank_legal_address: string;
  };
  contacts: { phone_display: string; phone_e164: string; email: string };
}

export const company: PublicCompanyDetails = generated;
export const phoneHref = `tel:${company.contacts.phone_e164}`;
export const emailHref = `mailto:${company.contacts.email}`;
